<template>
  <div class="Myorder">
    <div class="Myorder-background">
      <div class="appHelmetdwor">我的订单<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
        <div class="Myorder-Heaion">
          <div class="Myorder-Navition">
            <p v-for="(eiMyCommus,index) in MyCommus" :key="eiMyCommus" @click="myorOrpt(index)" :class="myornum == index ? 'Myorder-Navition-Select' : ''">{{eiMyCommus}}</p>
          </div>
        </div>
        <div class="Myorder-fill"></div>
        <div v-if="myoryftion != ''">
          <div v-for="eimyoryftion in myoryftion" :key="eimyoryftion.ID">
            <router-link :to="{path:'Wafopant',query: {myOrails: eimyoryftion.ID}}">
              <div class="Myorder-comity">
                <div class="Myorder-comity-title">
                  <p class="Myorder-comity-title-left">{{eimyoryftion.stroresName}}</p>
                  <p class="Myorder-comity-title-right" v-if="eimyoryftion.ORDER_STATE == '0'">待付款</p>
                  <p class="Myorder-comity-title-right" v-else-if="eimyoryftion.ORDER_STATE == '1'">待发货</p>
                  <p class="Myorder-comity-title-right" v-else-if="eimyoryftion.ORDER_STATE == '2'">待收货</p>
                  <p class="Myorder-comity-title-right" v-else-if="eimyoryftion.ORDER_STATE == '3'">已取消</p>
                  <p class="Myorder-comity-title-right" v-else-if="eimyoryftion.ORDER_STATE == '4'">已完成</p>
                  <p class="Myorder-comity-title-right" v-else-if="eimyoryftion.ORDER_STATE == '5'">已退款</p>
                  <p class="Myorder-comity-title-right" v-else-if="eimyoryftion.ORDER_STATE == '6'">已申请退款</p>
                  <p class="Myorder-comity-title-right" v-else-if="eimyoryftion.ORDER_STATE == '7'">已超时</p>
                  <p class="Myorder-comity-title-right" v-else-if="eimyoryftion.ORDER_STATE == '8'">退款已驳回</p>
                </div>
                <div class="Myorder-comity-img">
                  <div v-for="ereimyoryftion in eimyoryftion.shopMsg" :key="ereimyoryftion.ID">
                    <img :src="ereimyoryftion.goodsImages" alt="">
                    <span>{{ereimyoryftion.SHOP_NUMBER}}</span>
                  </div>
                </div>
                <div class="Myorder-comity-number">
                  <p class="Myorder-comity-number-left">{{eimyoryftion.PLACE_ORDER_DATE}}</p>
                  <p class="Myorder-comity-number-right" v-if="maluerID == '0'">共计{{eimyoryftion.shopSize}}件商品 ￥{{eimyoryftion.ACTUAL_PAYMENT ? eimyoryftion.ACTUAL_PAYMENT : eimyoryftion.MARKET_HJPRICE}}</p>
                  <p class="Myorder-comity-number-right" v-else-if="maluerID == '1' && eimyoryftion.shopMsg[0]">共计{{eimyoryftion.shopSize}}件商品 {{eimyoryftion.shopMsg[0].SCORE_PRICE}}</p>
                </div>
                <div class="Myorder-comity-oparde">
                  <button class="Myorder-comity-oparde-caner" v-if="eimyoryftion.ORDER_STATE == '0'">取消订单</button>
                  <button class="Myorder-comity-oparde-topay" v-if="eimyoryftion.ORDER_STATE == '0'">去支付</button>
                  <button class="Myorder-comity-oparde-caner" v-if="eimyoryftion.ORDER_STATE == '1' && maluerID == '0'">取消订单并退款</button>
                  <button class="Myorder-comity-oparde-topay" v-if="eimyoryftion.ORDER_STATE == '2'">确认收货</button>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="BuCardModel-bankcard-beemptyqb" v-else>暂无数据</div>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      MyorDipe: '',
      customerID: '',
      myoryftion: '',
      MyCommus: ['全部','待付款','待发货','待收货','已取消','已完成'],
      myornum: '',
      maluerID: ''
    }
  },
  created(){
    // 从缓存中获取用户的token
    this.customerID = localStorage.getItem("usertoken");
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    // 接收判断订单状态的参数
    this.myornum = this.$route.query.myTobeid;
    // 通过订单状态获取订单信息
    this.$axios.post('app/mallmerchantsOrderList',this.$qs.stringify({
      MEMBER_ID: this.customerID,
      ORDER_STATE: this.myornum == '0' ? '' : this.myornum - 1,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.myoryftion = res.data.varList;
    })
    .catch(() => {
      // console.log('未登录获取数据失败');
    });
  },
  mounted(){
    this.MyorHeon();
  },
  methods:{
    // 头部导航的下划线选择
    MyorHeon(){
      var that = this
      this.$('.Myorder-Navition p').on('click',function(){
        that.$(this).addClass('Myorder-Navition-Select');
        that.$(this).siblings().removeClass('Myorder-Navition-Select');
        that.MyorDipe = that.$(this).index();
      })
    },
    // 获取当前点击的订单状态
    myorOrpt(iexcnum){
      // 通过订单状态获取订单信息
      this.$axios.post('app/mallmerchantsOrderList',this.$qs.stringify({
        MEMBER_ID: this.customerID,
        ORDER_STATE: iexcnum == '0' ? '' : iexcnum - 1,
        MALL_TYPE: this.maluerID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        this.myoryftion = res.data.varList;
      })
      .catch(() => {
        // console.log('未登录获取数据失败');
      });
    },
    // 点击返回上一层
    appHelmetreturn(){
      if(this.maluerID == '0'){
        this.$router.push({name: 'ersoncal'});
      }else if(this.maluerID == '1'){
        this.$router.push({name: 'peracter'});
      }
    }
  }
}
</script>
<style scoped>
  @import "obraocs/Myorder.css";
</style>